"use client";

interface JobDetailsProps {
  description: string;
  compact?: boolean;
}

// Run-on string ko Q&A + description me todta hai
function parseJobDetails(raw: string) {
  const normalized = (raw || "")
    .replace(/\s+•\s+/g, "\n• ")
    .replace(/\s+✍️\s*DESCRIPTION:/gi, "\nDESCRIPTION:")
    .replace(/\s+DESCRIPTION:/gi, "\nDESCRIPTION:");
  const lines = normalized.split("\n");
  const items: { q: string; a: string }[] = [];
  let description = "";
  let inDescription = false;

  for (const line of lines) {
    if (line.toUpperCase().includes("DESCRIPTION:")) {
      inDescription = true;
      const afterLabel = line.split(/DESCRIPTION:/i)[1]?.trim();
      if (afterLabel) description += (description ? "\n" : "") + afterLabel;
      continue;
    }
    if (inDescription) {
      description += (description ? "\n" : "") + line;
      continue;
    }
    const trimmed = line.trim();
    if (trimmed.startsWith("•")) {
      const text = trimmed.replace("•", "").trim();
      const idx = text.indexOf(":");
      if (idx > -1) {
        items.push({ q: text.slice(0, idx).trim(), a: text.slice(idx + 1).trim() });
      }
    } else if (/^[^:]{8,120}:\s+/.test(trimmed)) {
      const idx = trimmed.indexOf(":");
      items.push({ q: trimmed.slice(0, idx).trim(), a: trimmed.slice(idx + 1).trim() });
    }
  }

  description = description.trim();
  // Agar structured format na mile to poora raw hi description maan lo
  if (items.length === 0 && !description) description = (raw || "").trim();

  return { items, description };
}

export function JobDetails({ description, compact = false }: JobDetailsProps) {
  const { items, description: desc } = parseJobDetails(description);
  const visibleItems = compact ? items.slice(0, 2) : items;

  return (
    <div className={compact ? "space-y-3" : "space-y-5"}>
      {items.length > 0 && (
        <div className={`grid grid-cols-1 ${compact ? "gap-2" : "sm:grid-cols-2 gap-4"}`} role="list">
          {visibleItems.map((it, i) => (
            <div
              key={i}
              className={compact
                ? "rounded-xl border border-slate-100 bg-slate-50 px-4 py-3"
                : "rounded-2xl bg-slate-50/80 border border-slate-200/70 px-5 py-4 shadow-sm shadow-slate-900/[0.02]"}
              role="listitem"
            >
              <p className={`${compact ? "text-[11px]" : "text-sm"} font-semibold text-slate-400 leading-snug`}>{it.q}</p>
              <p className={`${compact ? "text-sm mt-1" : "text-base mt-2"} font-black text-slate-950 leading-snug`}>{it.a}</p>
            </div>
          ))}
          {compact && items.length > visibleItems.length && (
            <p className="px-1 text-[10px] font-black uppercase tracking-widest text-emerald-600">
              +{items.length - visibleItems.length} more details
            </p>
          )}
        </div>
      )}

      {desc && (
        <div className={compact
          ? "border-l-2 border-emerald-500 bg-emerald-50/50 px-4 py-3 rounded-r-xl"
          : "border-l-4 border-emerald-600 bg-slate-50/80 px-6 py-5 rounded-r-2xl"}
        >
          <p className={`${compact ? "text-[9px]" : "text-xs"} font-black text-slate-400 uppercase tracking-[0.2em]`}>Description</p>
          <p className={`${compact ? "text-sm mt-1 line-clamp-2" : "text-base mt-2"} text-slate-800 whitespace-pre-line leading-relaxed`}>{desc}</p>
        </div>
      )}
    </div>
  );
}
